"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const Done = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M7.453 17.542a.75.75 0 0 0 1.102.065L20.02 6.54a.75.75 0 1 0-1.042-1.08L7.513 16.528l1.102.064L4.58 11.66a.75.75 0 0 0-1.162.95l4.034 4.932z", children: " " })
] });
var Done_default = Done;
export {
  Done_default as default
};
